import { FieldFormatSectionProps } from "./FieldFormatSection";
import { TW_FieldFormatSectionLine, TW_FieldFormatSectionLine_Label, TW_FieldFormatSectionLine_Select } from "@utils/twClasses";
import { useTranslation } from "react-i18next";
import { DATE_FORMATS } from "@utils/types";
import { DEFAULT_DATE_FORMAT } from "@utils/constants";


export function DateFieldFormatSection({ format, onFormatChange }: FieldFormatSectionProps) {

    const { t } = useTranslation();

    const dateFormat = (format && format.get("dateFormat")) ? format.get("dateFormat") : DEFAULT_DATE_FORMAT;

    return (
        <>
            <div className={TW_FieldFormatSectionLine}>
                <p className={TW_FieldFormatSectionLine_Label}>{t("field.format.label.DATE")}</p>
            
                <select className={TW_FieldFormatSectionLine_Select} value={dateFormat} onChange={onFormatChange("dateFormat", false)}>
                    {Array.from(DATE_FORMATS).map(([key, value]) => {
                        let i18nKey = "date.format.description." + key;
                        return <option key={"date-format-" + key} value={key} className="text-base">{t(i18nKey)}</option>
                    })}
                </select>
            </div>
        </>
    )
}
